import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Table from '@common/Table'
import store from '../store'
import getColumns from './column'

@observer
export default class extends Component {
  render() {
    return <Table store={store} columns={getColumns()} />
  }
}
